import declare from "dojo/_base/declare";
import EnumRen from "csi/heading/Enum";
import { Context } from "csi/def/Context";
import xml from "csi/xml";
import { C8Node } from "csi/typings";
import Heading from "csi/def/Heading";

const EnumReadOnlyTooltipRenderer = declare(EnumRen, {
	// Enable drag-fill
	bCopy: true,

	/**
	 * @override
	 * Disable tooltip if the field is not editable
	 */
	toTooltip(ctx: Context, h: Heading, tooltip: any) {
		const node: C8Node = ctx.getNode();

		if (!xml.nodeAttributeHasFlag(node, h.m_id, xml.ATTR_FLAGS_READONLY)) {
			this.inherited(arguments);
		}
	},
});

export = EnumReadOnlyTooltipRenderer;
